import RegularButtonLight from './RegularButtonLight';
import styled from 'styled-components';

export const LoadMoreButton = styled(RegularButtonLight)`
  margin-top: 20px;
  margin-bottom: 30px;
  width: 100%;
`;
